/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        // url: "https://api-verify.klefki.io/org-core/"
        // url: "https://staging-api-verify.klefki.io/org-core/"
        // url: "https://staging-govj-wp-gw.klefki.io/graphql"
        url: "https://dev-govj-wp-gw.klefki.io/scooby-gql"
      },
    ],
    rest: {
      loginServer: {
        baseURL: "https://dev-dc.vlinder.io/vlinder-login/",
      },
    },
  },
  defaultLoading: {
    image:
      "https://s3.amazonaws.com/io.vlinder.govj/Ministry-New-Logo-JPEG.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take few seconds, Please wait !",
  },
};
